import axios from "@/plugins/axios";

let initData = JSON.parse(localStorage.getItem("submarineApp"));
let token = initData && initData.token ? initData.token : "";
let user =
  initData && initData.user
    ? initData.user
    : {
        email: "",
        name: ""
      };

export default {
  namespaced: true,
  state: {
    token,
    user,
    error: false,
    agoraToken: null
  },
  mutations: {
    setUser(state, { user, token }) {
      state.user = user;
      state.token = token;
    },
    setAgoraToken(state, { token }) {
      state.agoraToken = token;
    },
    setError(state, error) {
      state.error = error;
    }
  },
  actions: {
    setUserLocalStorage(_, { user, token }) {
      localStorage.setItem("submarineApp", JSON.stringify({ token, user }));
    },
    // async getAgoraToken({ commit }) {
    //   // https://hv03w13bk1.execute-api.us-west-1.amazonaws.com/stage/agoraToken/test?diu=122
    //   let channel = "";
    //   let diu = "";
    //   const url = `https://hv03w13bk1.execute-api.us-west-1.amazonaws.com/stage/agoraToken/${channel}?diu=${diu}`;
    //   try {
    //     const { data } = await axios.get(url);
    //     commit("setAgoraToken", data);
    //   } catch (err) {
    //     //
    //   }
    // },
    signup({ commit, dispatch }, signupData) {
      commit("setError", false);
      const url = `/api/user`;

      return new Promise((resolve, reject) => {
        axios
          .post(url, signupData)
          .then(({ data }) => {
            if (data.error) {
              throw data.error;
            } else {
              commit("setUser", data);
              dispatch("setUserLocalStorage", data);
              resolve(data);
            }
          })
          .catch(error => {
            commit("setError", true);
            reject(error);
          });
      });
    },
    signin({ commit, dispatch }, signinData) {
      commit("setError", false);
      const url = `/api/session`;
      return new Promise((resolve, reject) => {
        axios
          .post(url, signinData)
          .then(({ data }) => {
            if (data.error) {
              throw data.error;
            } else {
              commit("setUser", data);
              dispatch("setUserLocalStorage", data);
              resolve(data);
            }
          })
          .catch(error => {
            commit("setError", true);
            reject(error);
          });
      });
    }
  }
};
